import { defineStore } from 'pinia';
import PublicService from '@/services/public.service';
import Option from '@/classes/Options/Option.class';

export const useOptionsStore = defineStore('Options', {
    state: () => ({
        id_module: null,
        list: [],
    }),
    actions: {
        async fetchAll() {
            this.list = [];
            let res = await PublicService.getOptions(this.id_module);
            if (res) {
                this.set(res);
            }
        },
        set(data) {
            this.list = [];
            for (let i = 0; i < data.length; i++) {
                let option = new Option();
                option.set(data[i]);
                this.list.push(option);
            }
        }
    },
    getters: {
        visibles_accueil() {
            return this.list.filter(option => option.visible_accueil == '1');
        },
        visibles_accueil_grouped() {
            let groups = [];
            for (let i = 0; i < this.list.length; i++) {
                let option = this.list[i];
                if (option.visible_accueil == '0') {
                    continue;
                }
                let group = option.get_metadata("nom_groupe_option");
                if (group == false) {
                    group = "Sans groupe";
                }
                let group_found = false;
                for (let j = 0; j < groups.length; j++) {
                    if (groups[j].name == group) {
                        groups[j].list.push(option);
                        group_found = true;
                        break;
                    }
                }
                if (!group_found) {
                    groups.push({ name: group, list: [option] });
                }
            }
            return groups;
        }

    },
});